import { Component, EventEmitter, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { SectionService } from "@airnauts/ng-components/section";
import { Subscription } from "rxjs";

@Component({
  selector: 'cosmos-stack-paginator',
  templateUrl: './stack-paginator.component.html',
  styleUrls: ['./stack-paginator.component.scss'],
})
export class StackPaginatorComponent implements OnInit, OnDestroy {
  @Output() public readonly backEvent = new EventEmitter<never>();
  @Output() public readonly nextEvent = new EventEmitter<never>();

  private _values: string[] = [];
  private _nextCursor: string | null | undefined = null;
  private _subscription: Subscription = new Subscription();

  public _loading: boolean = false;

  public static create(param: { valuesSoFar?: Iterable<string>, nextValue?: string }) {
    const component = new StackPaginatorComponent(new SectionService());
    if (param.valuesSoFar) {
      component._values = [...param.valuesSoFar];
    }
    if (param.nextValue) {
      component._nextCursor = param.nextValue;
    }
    return component;
  }

  public constructor(
    @Optional() private readonly _sectionService?: SectionService,
  ) { }

  public ngOnInit(): void {
    if (this._sectionService) {
      this._subscription.add(
        this._sectionService.loading$.subscribe(next => this._loading = next),
      );
    }
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public get value(): string {
    return this._values[this._values.length - 1] ?? null;
  }

  public get hasNext(): boolean {
    return !!this._nextCursor;
  }

  public get hasBack() {
    return this._values.length > 0;
  }

  public update(meta: { nextCursor: string | null; }) {
    this._nextCursor = meta.nextCursor;
  }

  public next() {
    if (!this.hasNext) {
      throw Error('Programming error, forgot to check hasNexy before next');
    }
    this._values.push(this._nextCursor!);
    this._nextCursor = null;
    this.nextEvent.emit();
  }

  public back() {
    if (!this.hasBack) {
      throw Error('Programming error, forgot to check hasBack before back');
    }
    this._nextCursor = null;
    this._values.pop();
    this.backEvent.emit();
  }

  public reset() {
    this._values = [];
    this._nextCursor = null;
  }
}
